import { ReactNode, createContext, useContext, useState } from 'react';

import { FadeAnimationPageKey } from '@src/types/providers';

interface FadeContextState {
  animationsCompleted: Record<FadeAnimationPageKey, boolean>;
  setAnimationCompleted: (pageKey: FadeAnimationPageKey) => void;
}

const FadeContext = createContext<Nullable<FadeContextState>>(null);

const useFade = () => {
  const context = useContext(FadeContext);
  if (!context) {
    throw new Error('useFade must be used within a FadeProvider');
  }
  return context;
};

const FadeProvider = ({ children }: { children: ReactNode }) => {
  const [animationsCompleted, setPageAnimationCompleted] = useState({
    bundlePage: false,
    cashbackPage: false,
    default: false,
  });

  const setAnimationCompleted = (pageKey: FadeAnimationPageKey) => {
    switch (pageKey) {
      case 'bundlePage':
        setPageAnimationCompleted((prev) => ({ ...prev, bundlePage: true }));
        break;
      case 'cashbackPage':
        setPageAnimationCompleted((prev) => ({ ...prev, cashbackPage: true }));
        break;
      case 'default':
      default:
        break;
    }
  };

  return (
    <FadeContext
      value={{
        animationsCompleted,
        setAnimationCompleted,
      }}
    >
      {children}
    </FadeContext>
  );
};

export { FadeContext, useFade, FadeProvider };
